module.exports = __webpack_public_path__ + "static/not-available-f228fdd55ec7477271dee51823570651.png";